// extracted by mini-css-extract-plugin
export var button = "ColorInput-module__button";
export var chromePicker = "ColorInput-module__chrome-picker";
export var focus = "ColorInput-module__focus";
export var picking = "ColorInput-module__picking";
export var popover = "ColorInput-module__popover";
export var root = "ColorInput-module__root";
export var swatch = "ColorInput-module__swatch";
export var value = "ColorInput-module__value";